import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useLocalStorageState from "use-local-storage-state";

import useQueries from "./useQueries";

const useBuddy = () => {
  let { projectId = "global-graph", projectPublicId } = useParams();
  const { promptTemplates } = useQueries();

  const isReadOnly = Boolean(projectPublicId);

  const [buddyId, setBuddyId] = useLocalStorageState<string>(
    `ldgV2BuddyId-${projectPublicId ? projectPublicId : projectId}`,
    { defaultValue: "87e503e8-14ba-4e95-b31c-e626d5cb7752" }
  );
  const buddy = promptTemplates.find((buddy) => buddy.id == buddyId);

  return {
    buddy,
    buddyId,
    setBuddyId,
  };
};

export default useBuddy;
